import {hasSession} from './hasAccount';

export default function authOnEnter() {  
  return hasSession();
}